/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import Checkbox from '@taglivros/oef_componentes/build/components/checkbox'

import { bool, func } from 'prop-types'
import OpcionaisPagamentoCartao from './FormaPagamento/OpcionaisPagamentoCartao'
import OpcionaisPagamentoPix from './FormaPagamento/OpcionaisPagamentoPix'
import OpcionaisConclusaoCartao from './FormaPagamento/OpcionaisConclusaoCartao'
import OpcionaisConclusaoPix from './FormaPagamento/OpcionaisConclusaoPix'
import { useOpcionais } from '../../../contexts/OpcionaisContext'
import { useGlobal } from '../../../contexts/GlobalContext'
import {
  METODO_PAGAMENTO_CARTAO,
  MODALIDADE_CURADORIA,
  MODALIDADE_INEDITOS
} from '../../../constants'
import {
  INFO_OPCIONAIS_COMBO,
  INFO_OPCIONAIS_SELECIONADOS
} from '../constantsCardOpcionais'
import { formatValor } from '../../../utils/formatter/formatter'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'

const WrapperInfoPagamentoOpcional = styled.div`
  width: 100%;

  .opcional-pagamento-info-produto {
    width: 100%;

    & > p {
      margin-top: 0;
    }

    .opcional-pagamento-info-produto-listagem {
      max-width: 300px;
      li {
        display: flex;
        justify-content: space-between;
        ${StyleGuide.tipografia.textoPequeno}
        margin-bottom: 10px;
      }
      span {
        padding-right: 10 px;
      }
    }
  }

  .opcionais-combo {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;

    fieldset {
      width: ${( { numeroModalidades } ) => numeroModalidades > 1 ? '50%' : '100%'};
    }
  }
`

const ModalPagamentoOpcionais = ( { showModal, toggleModal } ) => {
  const {
    dadosOpcionais,
    finalizarCompraOpcionais,
    loadingRequisicaoCompraOpcionais,
    modalidadesEscolhidaOpcionais,
    opcionaisSelecionados,
    setModalidadesEscolhidaOpcionais
  } = useOpcionais()
  const { modalidadesDaAssinatura } = useGlobal()
  // eslint-disable-next-line react/hook-use-state
  const [ modalidadesOpcionaisCombo ] = useState()
  const [ modalidadesPodeComprar, setModalidadesPodeComprar ] = useState()

  useEffect( () => {
    if ( modalidadesDaAssinatura.length === 1 ) {
      setModalidadesEscolhidaOpcionais( [ modalidadesDaAssinatura[ 0 ] ] )
    } else if ( modalidadesDaAssinatura.length >= 2 ) {
      const modalidadesOpcionaisSelecionados = opcionaisSelecionados.flatMap( opcional => opcional.categoriaId )

      const modalidades = [ ...new Set( modalidadesOpcionaisSelecionados ) ]

      if ( modalidades.length === 1 ) {
        const modalidadeCorreta =
          modalidades[ 0 ] === MODALIDADE_CURADORIA.id
            ? MODALIDADE_CURADORIA.visualizacao
            : MODALIDADE_INEDITOS.visualizacao
        setModalidadesEscolhidaOpcionais( [ modalidadeCorreta ] )
      } else {
        setModalidadesPodeComprar( modalidades.sort() )
      }
    }
  }, [ modalidadesOpcionaisCombo ] )

  const selecionarModalidadeCombo = modalidade => {
    if ( modalidadesEscolhidaOpcionais.includes( modalidade ) ) {
      const opcoes = modalidadesEscolhidaOpcionais.filter( modalidadeNaoClicada => modalidadeNaoClicada !== modalidade )
      setModalidadesEscolhidaOpcionais( opcoes )
    } else if ( opcionaisSelecionados.length > 1 ) {
      setModalidadesEscolhidaOpcionais( [ modalidade ] )
    } else {
      const selecionados = [ ...modalidadesEscolhidaOpcionais, modalidade ]
      setModalidadesEscolhidaOpcionais( selecionados )
    }
  }

  const conclusaoOpcionais = () => {
    if (
      dadosOpcionais.formaPagamento === METODO_PAGAMENTO_CARTAO.visualizacao
    ) {
      return <OpcionaisConclusaoCartao fecharModal={ toggleModal } />
    } else {
      return <OpcionaisConclusaoPix fecharModal={ toggleModal } />
    }
  }

  return (
    <Modal
      altura="auto"
      onShowModal={ () => toggleModal() }
      show={ showModal }
    >
      <WrapperInfoPagamentoOpcional
        numeroModalidades={
          modalidadesOpcionaisCombo ? modalidadesOpcionaisCombo.length : null
        }
      >
        {finalizarCompraOpcionais ? (
          conclusaoOpcionais()
        ) : (
          <>
            {loadingRequisicaoCompraOpcionais ? (
              <InlineLoader isCenter />
            ) : (
              <>
                <div className="opcional-pagamento-info-produto">
                  <p>{INFO_OPCIONAIS_SELECIONADOS}</p>

                  <ul className="opcional-pagamento-info-produto-listagem">
                    {opcionaisSelecionados.map( opcional => {
                      return (
                        <li key={ opcional.id }>
                          <span>{`- ${opcional.descricao}`}</span>

                          <span>{formatValor( { 'valor': opcional.preco } )}</span>
                        </li>
                      )
                    } )}
                  </ul>

                  {modalidadesPodeComprar?.length > 1 &&
                    opcionaisSelecionados &&
                    opcionaisSelecionados.length ? <p>{INFO_OPCIONAIS_COMBO}</p> : null}
                </div>

                <div className="opcionais-combo">
                  {modalidadesPodeComprar &&
                    modalidadesDaAssinatura.length > 1 &&
                    opcionaisSelecionados ? modalidadesPodeComprar.map( modalidade => {
                      return (
                        <Checkbox
                          click={ () => selecionarModalidadeCombo( modalidade ) }
                          isChecked={ modalidadesEscolhidaOpcionais.includes( modalidade ) }
                          key={ modalidade }
                          label={
                            MODALIDADE_CURADORIA.id === modalidade
                              ? MODALIDADE_CURADORIA.visualizacao
                              : MODALIDADE_INEDITOS.visualizacao
                          }
                        />
                      )
                    } ) : null}
                </div>

                <div>
                  { dadosOpcionais.formaPagamento === METODO_PAGAMENTO_CARTAO.visualizacao ? (
                    <OpcionaisPagamentoCartao
                      fecharModal={ () => toggleModal() }
                    />
                  ) : (
                    <OpcionaisPagamentoPix
                      fecharModal={ () => toggleModal() }
                    />
                  )}
                </div>
              </>
            )}
          </>
        )}
      </WrapperInfoPagamentoOpcional>
    </Modal>
  )
}

ModalPagamentoOpcionais.defaultProps = {
  'showModal': true,
  'toggleModal': null
}

ModalPagamentoOpcionais.propTypes = {
  'showModal': bool,
  'toggleModal': func
}

export default ModalPagamentoOpcionais
